import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { reset } from '../redux/customKpiSlice'
import { clearKpiAction } from '../redux/customKpiDetailsSlice'

const useCleanup = (): void => {
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    return () => {
      dispatch(reset())
      dispatch(clearKpiAction())
    }
  }, [location])
}

export default useCleanup
